module.exports = __webpack_public_path__ + "images/36dabb73.pay_5.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_5.png
// module id = 498
// module chunks = 0